import { Chip } from '@zep-us/zus';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { BookcoverFillIcon, PlusSmallIcon, SquareGridFillIcon } from '@zep-us/zus-icons';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { setReferrer } from '@/shared/features/enter-referrer-tracking';
import { useIsInGoogleClassroom } from '@/shared/googleClassroom';
import { DialogBody, DialogHeader, ResponsiveDialog } from '@/ui_v3/components/dialog/dialog';
import { type EventProperties } from '@/utils/analytics';
import { cn } from '@/utils/tailwind.util';
interface CreateQuizBannerModalProps {
  onClose: () => void;
}
export const CreateQuizBannerModal = ({
  onClose
}: CreateQuizBannerModalProps) => {
  const {
    t
  } = useTranslation('common');
  const router = useRouter();
  const isInGoogleClassroom = useIsInGoogleClassroom();
  const trackCreate = (contentType: 'quiz' | 'board') => {
    const eventProperties: EventProperties = {
      content_type: contentType,
      from: 'public_banner'
    };
    if (isInGoogleClassroom) {
      eventProperties.extension = 'google_classroom';
    }
    logger.track('enter_create', {
      ...eventProperties,
      location: 'public'
    });
  };
  const handleCreateQuiz = () => {
    trackCreate('quiz');
    setReferrer({
      from: 'public_banner'
    });
    onClose();
    void router.push('/build');
  };
  const handleCreateBoard = () => {
    trackCreate('board');
    onClose();
    setReferrer({
      from: 'public_banner'
    });
    void router.push('/board/new');
  };
  return <ResponsiveDialog onClose={onClose} size="sm" data-sentry-element="ResponsiveDialog" data-sentry-component="CreateQuizBannerModal" data-sentry-source-file="CreateQuizBannerModal.tsx">
      <DialogHeader title={t('gnb.create.title')} hasCloseButton onClose={onClose} data-sentry-element="DialogHeader" data-sentry-source-file="CreateQuizBannerModal.tsx" />
      <DialogBody className="px-md pb-md mobile-lg:px-lg mobile-lg:pb-lg" data-sentry-element="DialogBody" data-sentry-source-file="CreateQuizBannerModal.tsx">
        <p className="pb-xs text-body-sm-medium text-alternative">
          {t('gnb.create.description')}
        </p>
        <div className="flex flex-col">
          <button onClick={handleCreateQuiz} className={cn('flex items-center gap-sm rounded-sm px-sm py-md', 'hover:bg-neutral transition-colors')}>
            <BookcoverFillIcon size="sm" className="text-blue-500" data-sentry-element="BookcoverFillIcon" data-sentry-source-file="CreateQuizBannerModal.tsx" />
            <span className="flex-1 text-left text-body-lg-bold">
              {t('gnb.create.quiz')}
            </span>
            <PlusSmallIcon size="sm" fill={ICON_COLOR.alternative} data-sentry-element="PlusSmallIcon" data-sentry-source-file="CreateQuizBannerModal.tsx" />
          </button>
          <button onClick={handleCreateBoard} className={cn('flex items-center gap-sm rounded-sm px-sm py-md', 'hover:bg-neutral transition-colors')}>
            <SquareGridFillIcon size="sm" className="text-purple-500" data-sentry-element="SquareGridFillIcon" data-sentry-source-file="CreateQuizBannerModal.tsx" />
            <div className="flex flex-1 items-center gap-xs text-left">
              <span className="text-body-lg-bold">{t('gnb.create.board')}</span>
              <Chip size="xs" rounded="full" className="border-opacity-assistive bg-yellow-50 px-2xs text-caption-md-semibold text-yellow-900" data-sentry-element="Chip" data-sentry-source-file="CreateQuizBannerModal.tsx">
                Beta
              </Chip>
            </div>
            <PlusSmallIcon size="sm" fill={ICON_COLOR.alternative} data-sentry-element="PlusSmallIcon" data-sentry-source-file="CreateQuizBannerModal.tsx" />
          </button>
        </div>
      </DialogBody>
    </ResponsiveDialog>;
};